import React, { useEffect, useState } from "react";

import { getSearchValue } from "app/utils";
import { getUnsplashRandomImage } from "app/utils/unsplash";

import { StoryQuestion } from "chq";
import { Loader, classnames } from "@culturehq/components";
import { useProfile } from "app/context";
import hasCustomImageLibrary from "app/utils/hasCustomImageLibrary";
import getCustomImageLibrary from "./post-stories-v2/common/PostStoryForm/custom-image-library/getCustomImageLibrary";

type PromptImageProps = {
  className?: string;
  prompt: StoryQuestion;
};

const PromptImage: React.FC<PromptImageProps> = ({ className, prompt }) => {
  const [image, setImage] = useState<any>();
  const [searchValue] = useState(getSearchValue(prompt));
  const { profile: { organization: { name: orgName } } } = useProfile();
  const hasLibrary = hasCustomImageLibrary(orgName);

  useEffect(
    () => {
      let isMounted = true;

      const getRandomImage = async (tag: string, hasLibrary: boolean) => {
        if (hasLibrary) {
          const images = getCustomImageLibrary(orgName);
          const max = images.length - 1;
          const randomNum = Math.floor(Math.random() * (max)) + 1;
          const result = { urls: { thumb: images[randomNum].urls.regular } };
          if (isMounted) setImage(result);
        } else {
          const result = await getUnsplashRandomImage(tag);
          if (isMounted) setImage(result);
        }
      };

      if (prompt?.smallUrl || prompt?.fullUrl || prompt?.imageUrl) {
        setImage(prompt?.smallUrl || prompt?.fullUrl || prompt?.imageUrl);
      } else {
        getRandomImage(searchValue, hasLibrary);
      }

      return () => {
        isMounted = false;
      };
    },
    [hasLibrary, orgName, prompt, searchValue]
  );

  return (
    <div
      className={classnames(className, "Story--Image")}
      style={{ backgroundImage: `url(${image?.urls?.thumb || image})` }}
    >
      <Loader loading={!image} />
    </div>
  );
};

export default PromptImage;
